import { render, staticRenderFns } from "./transfer-confirmation.vue?vue&type=template&id=635ed194&scoped=true&"
import script from "./transfer-confirmation.vue?vue&type=script&lang=tsx&"
export * from "./transfer-confirmation.vue?vue&type=script&lang=tsx&"
import style0 from "./transfer-confirmation.vue?vue&type=style&index=0&id=635ed194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ed194",
  null
  
)

export default component.exports